import { css, html, LitElement } from "lit";

import { DOWNLOAD_URL } from "../../constants";
import { fetchUserData } from "../common/api";
import { setUserData, userData } from "../common/client";

export class NavbarComponent extends LitElement {
  static get properties() {
    return {
      isMobileMenuOpen: { type: Boolean, state: true },
    };
  }

  constructor() {
    super();
    this.isMobileMenuOpen = false;
    this.isLoaded = false;
  }

  static get styles() {
    return css`
      :host {
        display: block;
        width: 100%;
        background: #FFF;
        backdrop-filter: blur(10px);
        border-bottom: 2px solid rgb(65, 138, 207);
        position: fixed;
        top: 0;
        z-index: 10000;
      }

      .navbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.5rem 1rem;
        max-width: 1200px;
        margin: 0 auto;
        height: 60px;
      }

      .logo {
        display: flex;
        align-items: center;
        text-decoration: none;
        color: white;
        font-size: 1.5rem;
        font-weight: bold;        
        letter-spacing: 1px;
      }

      .logo-image {
        height: 40px;
        width: auto;
        margin-right: 0.75rem;
      }

      .logo-text {
        color: rgb(65, 138, 207);
        text-shadow:
          -1px -1px 0 #000,
          1px -1px 0 #000,
          -1px 1px 0 #000,
          1px 1px 0 #000;
      }

      /* Desktop Navigation */
      .nav-menu {
        display: none;
        list-style: none;
        margin: 0;
        padding: 0;
        gap: 2rem;
      }

      .nav-item {
        position: relative;
      }

      .nav-link {
        color: #444040;
        text-decoration: none;
        font-size: 1rem;
        font-weight: 700;        
        letter-spacing: 0.5px;
        padding: 0.5rem 1rem;
        border-radius: 4px;
        transition: all 0.3s ease;
        position: relative;
        display: block;
        text-transform: uppercase;
      }

      .nav-link:hover {
        color: rgb(65, 138, 207);
        background: rgba(65, 138, 207, 0.1);
      }

      .nav-link.active {
        color: rgb(65, 138, 207);
        text-shadow:
          -1px -1px 0 #000,
          1px -1px 0 #000,
          -1px 1px 0 #000,
          1px 1px 0 #000;
      }

      .nav-link.active::after {
        content: "";
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-50%);
        width: 80%;
        height: 2px;
        background: rgb(65, 138, 207);
        box-shadow: 0 0 5px rgba(65, 138, 207, 0.5);
      }

      .user-img {
        width: 40px;
        border: 1px solid #fff;
        border-radius: 50%;
      }

      .user-img:hover {
        border: 1px solid rgb(65, 138, 207);
      }
      
      .discord-login-button {
        background-size: 20px;
        background-position: center;
        background-repeat: no-repeat;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background-color: #5865f2;
        color: white;
        text-decoration: none;
        border: none;
        border-radius: 5px;
        padding: 2px;
        transition: background-color 0.3s ease, transform 0.2s ease;
        height: 35px;
        width: 35px;
      }

      .mobile-profile {
        position: absolute;
        top: 16px;
        right: 75px;
      }

      /* Mobile Menu Button */
      .mobile-menu-button {
        display: block;
        background: none;
        border: 2px solid rgb(65, 138, 207);
        color: rgb(65, 138, 207);
        padding: 0.5rem;
        border-radius: 4px;
        cursor: pointer;
        font-size: 1.25rem;
        transition: all 0.3s ease;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .mobile-menu-button:hover {
        background: rgba(65, 138, 207, 0.1);
        box-shadow: 0 0 10px rgba(65, 138, 207, 0.3);
      }

      .hamburger {
        display: flex;
        flex-direction: column;
        gap: 3px;
      }

      .hamburger span {
        width: 20px;
        height: 2px;
        background: rgb(65, 138, 207);
        transition: all 0.3s ease;
        transform-origin: center;
      }

      .hamburger.open span:nth-child(1) {
        transform: rotate(45deg) translate(5px, 5px);
      }

      .hamburger.open span:nth-child(2) {
        opacity: 0;
      }

      .hamburger.open span:nth-child(3) {
        transform: rotate(-45deg) translate(2px, -3px);
      }

      /* Mobile Menu */
      .mobile-menu {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: #FFF;
        backdrop-filter: blur(15px);
        border-bottom: 2px solid rgb(65, 138, 207);
        display: none;
        padding: 1rem 0;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
      }

      .mobile-menu.open {
        display: block;
        animation: slideDown 0.3s ease-out;
      }

      @keyframes slideDown {
        from {
          opacity: 0;
          transform: translateY(-10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .mobile-menu .nav-menu {
        display: flex;
        flex-direction: column;
        padding: 0 1rem;
        gap: 0;
      }

      .mobile-menu .nav-link {
        padding: 0.75rem 1rem;
        border-bottom: 1px solid rgba(65, 138, 207, 0.2);
      }

      .mobile-menu .nav-link:last-child {
        border-bottom: none;
      }

      /* Desktop Styles */
      @media (min-width: 768px) {
        .navbar {
          padding: 0.75rem 2rem;
        }

        .nav-menu {
          display: flex;
        }

        .mobile-menu-button {
          display: none;
        }

        .mobile-profile {
          display: none;
        }

        .mobile-menu {
          display: none !important;
        }

        .logo-image {
          height: 70px;
        }

        .logo {
          font-size: 1rem;
        }

        .nav-link {
          font-size: 1rem;
        }
      }

      /* Large Desktop */
      @media (min-width: 1024px) {
        .navbar {
          height: 70px;
        }

        .logo-image {
          height: 80px;
        }

        .logo {
          font-size: 1rem;
        }

        .nav-menu {
          gap: 2rem;
        }

        .nav-link {
          font-size: 1rem;
          padding: 0.75rem 1.25rem;
        }
      }
    `;
  }

  _toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  _closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  firstUpdated() {
    if (!userData?.id) {
      this.loadUserData();
    } else {
      this.isLoaded = true;
      this.requestUpdate();
    }
  }

  /**
   * Load the user data from the server.
   */
  async loadUserData() {
    const data = await fetchUserData();
    if (data) {
      setUserData(data);
    }
    this.isLoaded = true;
    this.requestUpdate();
  }

  render() {
    const userButton = this.isLoaded
      ? html`${
          userData?.id
            ? html`
      <a href="./user/${userData.id}">
      <img
      class="user-img"
      src=${
        userData.avatar
          ? `https://cdn.discordapp.com/avatars/${userData.id}/${userData.avatar}.png`
          : "./images/logo.jpeg"
      }
      /></a>`
            : html`
      <a href="./auth/login" class="discord-login-button" style="background-image: url('./images/disc.svg');">          
      </a>`
        }`
      : "";
    return html`
      <nav class="navbar">
        <!-- Logo -->
        <a href="./" class="logo">
          <img
            src="./images/logo.jpeg"
            alt="Plane Pals"
            class="logo-image"
          />
        </a>

        <!-- Desktop Navigation -->
        <ul class="nav-menu">
          <li class="nav-item">
            <a href="${DOWNLOAD_URL}" target="_blank" class="nav-link"> Download </a>
          </li>
          <li class="nav-item">
            <a href="./live-map" class="nav-link"> Live Map </a>
          </li>
          <li class="nav-item">
            <a href="./leaderboard" class="nav-link"> Leaderboard </a>
          </li>
          <li class="nav-item">
            ${userButton}
          </li>
        </ul>

        <div class="mobile-profile">
         ${userButton}
        </div>

        <!-- Mobile Menu Button -->
        <button
          class="mobile-menu-button"
          @click="${this._toggleMobileMenu}"
          aria-label="Toggle mobile menu"
        >
          <div class="hamburger ${this.isMobileMenuOpen ? "open" : ""}">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </button>
      </nav>

      <!-- Mobile Menu -->
      <div class="mobile-menu ${this.isMobileMenuOpen ? "open" : ""}">
        <ul class="nav-menu">
          <li class="nav-item">
            <a href="${DOWNLOAD_URL}" target="_blank" class="nav-link"> Download </a>
          </li>
          <li class="nav-item">
            <a href="./live-map" class="nav-link"> Live Map </a>
          </li>
          <li class="nav-item">
            <a href="./leaderboard" class="nav-link"> Leaderboard </a>
          </li>
        </ul>
      </div>
    `;
  }
}

customElements.define("navbar-component", NavbarComponent);
